export default __webpack_public_path__ + "static/Robert Rosas-d9e65fc73a23b1673000d79519767a26.png";